/*
 * K-Beauty Real Gems — collection page (Phase 4).
 * - AJAX facet updates: intercept any facet click → fetch the URL with
 *   `?sections=krg-main-collection`, swap the section's grid + rails in
 *   place, push the new URL to history. No full reload.
 * - Load More: same idea, append to the grid + replace the load-more href.
 * - Mobile drawer: tabbed Brand/Category/Concern/Skin Type, multi-select
 *   chips fed by `.krg-active` facet links, Apply triggers a fetch with all
 *   active values, Clear nukes them.
 * - Add to Bag on cards uses the global KRGCart helper (Phase 3).
 */
(function () {
  'use strict';

  var SECTION_ID = 'krg-main-collection';
  var rootSel = '[data-krg-collection]';
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(s, root) { return (root || document).querySelector(s); }
  function $$(s, root) { return Array.from((root || document).querySelectorAll(s)); }

  /* ---------- Section swap helpers ---------- */
  function fetchAndSwap(url) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + sep + 'sections=' + SECTION_ID;
    return fetch(fetchUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $(rootSel, tmp);
        var current = $(rootSel);
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        // Also replace the mobile drawer for fresh facet state.
        var freshDrawer = tmp.querySelector('[data-krg-filter-drawer]');
        var currentDrawer = document.querySelector('[data-krg-filter-drawer]');
        if (freshDrawer && currentDrawer) {
          var wasOpen = currentDrawer.classList.contains('krg-filter-drawer--open');
          currentDrawer.outerHTML = freshDrawer.outerHTML;
          if (wasOpen) document.querySelector('[data-krg-filter-drawer]').classList.add('krg-filter-drawer--open');
        }
        history.pushState({}, '', url);
        window.scrollTo({ top: 0, behavior: 'instant' });
      });
  }

  function appendNextPage(url, btn) {
    // Fetch the next page as a FULL HTML document and parse it, rather than via
    // the Section Rendering API (`?sections=`). Section rendering does not
    // reliably honor the `page` param across environments, which left Load More
    // silently failing (empty response → JSON parse error → nothing appended).
    if (btn) { btn.setAttribute('disabled', 'true'); btn.classList.add('is-loading'); }
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status + ' fetching ' + url);
        return r.text();
      })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var freshGrid = doc.querySelector('[data-krg-grid]');
        var currentGrid = document.querySelector('[data-krg-grid]');
        if (freshGrid && currentGrid) currentGrid.insertAdjacentHTML('beforeend', freshGrid.innerHTML);
        // Swap in the fresh load-more (carries the next page's URL), or drop it
        // when the last page is reached.
        var freshLM = doc.querySelector('[data-krg-load-more-wrap]');
        var currentLM = document.querySelector('[data-krg-load-more-wrap]');
        if (currentLM) {
          if (freshLM) currentLM.outerHTML = freshLM.outerHTML;
          else currentLM.remove();
        }
        history.pushState({}, '', url);
      })
      .catch(function (err) {
        // Re-enable the button so the shopper can retry; surface for debugging.
        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); }
        if (window.console) console.error('[KRG] Load More failed:', err);
      });
  }

  /* ---------- Delegated click handlers ---------- */
  document.addEventListener('click', function (e) {
    // Facet link
    var facet = e.target.closest('[data-krg-facet]');
    if (facet) {
      e.preventDefault();
      fetchAndSwap(facet.getAttribute('href'));
      return;
    }

    // Load more
    var lm = e.target.closest('[data-krg-load-more]');
    if (lm) {
      e.preventDefault();
      if (lm.hasAttribute('disabled')) return;
      var next = lm.getAttribute('data-next-url');
      if (next) appendNextPage(next, lm);
      return;
    }

    // Mobile drawer open/close
    if (e.target.closest('[data-krg-filter-open]')) {
      var d = document.querySelector('[data-krg-filter-drawer]');
      if (d) {
        d.classList.add('krg-filter-drawer--open');
        d.setAttribute('aria-hidden', 'false');
        document.body.classList.add('krg-filter-open');
        refreshDrawerChips();
      }
      return;
    }
    if (e.target.closest('[data-krg-filter-close]')) {
      closeDrawer();
      return;
    }
    if (e.target.closest('[data-krg-filter-clear]')) {
      // Navigate to the base collection URL without any params.
      var base = location.pathname;
      fetchAndSwap(base).then(closeDrawer);
      return;
    }
    if (e.target.closest('[data-krg-filter-apply]')) {
      closeDrawer();
      return;
    }
    var tab = e.target.closest('[data-krg-fd-tab]');
    if (tab) {
      var key = tab.getAttribute('data-krg-fd-tab');
      var wrap = tab.closest('[data-krg-filter-drawer]');
      $$('[data-krg-fd-tab]', wrap).forEach(function (t) { t.classList.toggle('krg-fd-tab--active', t === tab); });
      $$('[data-krg-fd-panel]', wrap).forEach(function (p) {
        p.classList.toggle('krg-fd-panel--active', p.getAttribute('data-krg-fd-panel') === key);
      });
      return;
    }

    // Card "Add to Bag" is handled globally in krg-cart.js (works on
    // collection cards + PDP upsell). Only intercept here to stop the click
    // from bubbling to the card's parent link (which would navigate away).
    var cardAdd = e.target.closest('[data-krg-card-add]');
    if (cardAdd) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  });

  function closeDrawer() {
    var d = document.querySelector('[data-krg-filter-drawer]');
    if (!d) return;
    d.classList.remove('krg-filter-drawer--open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('krg-filter-open');
  }

  /* ---------- Drawer chips (selected facet values) ---------- */
  function refreshDrawerChips() {
    var drawer = document.querySelector('[data-krg-filter-drawer]');
    if (!drawer) return;
    var actives = $$('[data-krg-facet].krg-active', drawer);
    var chipsWrap = drawer.querySelector('[data-krg-fd-chips]');
    var selectedRow = drawer.querySelector('[data-krg-fd-selected]');
    var countEl = drawer.querySelector('[data-krg-fd-count]');
    if (chipsWrap) chipsWrap.innerHTML = actives.map(function (a) {
      return '<button type="button" class="krg-fd-chip" data-krg-fd-chip data-href="' + a.getAttribute('href') + '">' + a.getAttribute('data-value') + ' <span>×</span></button>';
    }).join('');
    if (selectedRow) selectedRow.hidden = actives.length === 0;
    if (countEl) countEl.textContent = actives.length;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-krg-fd-chip]');
    if (chip) {
      e.preventDefault();
      // Each chip's href is the active facet's url_to_remove.
      var url = chip.getAttribute('data-href');
      if (url) fetchAndSwap(url).then(refreshDrawerChips);
    }
  });

  /* ---------- Browser back/forward ---------- */
  window.addEventListener('popstate', function () {
    fetchAndSwap(location.href);
  });
})();
